<template>
  <div>
    <!-- 产品增加 -->
    <!-- <el-dialog :title="operate === 'edit'?'编辑产品':'添加产品'" :close-on-click-modal="false" :visible="currentStep=== 1" class="imgbox" width="40%" :append-to-body="true" :before-close="closeDialog"> -->
    <el-form label-width="110px" ref="ruleForm" :rules="rules" :model="form">
      <el-row :span="24">
        <el-col :span="12">

        </el-col>
        <el-col :span="12">

        </el-col>
      </el-row>
      <el-row :span="24">
        <el-col :span="12">
          <el-form-item label="产品名称" prop="productName">
            <el-input v-model="form.productName" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品品类" prop="category">
            <el-input v-if="operate === 'edit'" disabled readonly ref="categoryInput" placeholder="请选择标准品类"
              suffix-icon="el-icon-arrow-down" v-model="productDetail.categoryName">
            </el-input>
            <el-input v-else readonly @focus="focusStatus && openDrawer()" ref="categoryInput" placeholder="请选择标准品类"
              suffix-icon="el-icon-arrow-down" v-model="categoryName">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :span="24">
        <el-col :span="12">
          <el-form-item label="产品标识符" prop="" :required="status">
            <el-input placeholder="请输入产品标识符" v-model="form.productKey">
            </el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
             <el-form-item label="物模型类型" prop="productModelType">
              <el-radio-group  v-model="form.productModelType">
                <el-radio v-if="form.productModelType===0" :label="0">标准品类物模型</el-radio>
                <el-radio v-if="form.productModelType===1" :label="1">自定义物模型</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col> -->
      </el-row>

      <el-row :span="24">
        <el-col :span="12">
          <el-form-item label="节点类型" prop="nodeType">
            <el-select v-model="form.nodeType" placeholder="请选择节点类型" style="width: 100%;">
              <el-option v-for="item in nodeTypeOptions" :key="item.nodeTypeKey" :label="item.nodeTypeName"
                :value="item.nodeTypeKey">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="连网方式" prop="connectionType">
            <el-select v-model="form.connectionType" placeholder="请选择连网方式" style="width: 100%;">
              <el-option v-for="item in connectionTypeOptions" :key="item.connectionTypeKey"
                :label="item.connectionTypeName" :value="item.connectionTypeKey">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :span="24">
        <el-col :span="12">
          <el-form-item label="数据格式" prop="dataFormat">
            <el-select v-model="form.dataFormat" placeholder="请选择数据格式" style="width: 100%;">
              <el-option v-for="item in dataFormatOptions" :key="item.dataFormatKey" :label="item.dataFormatName"
                :value="item.dataFormatKey">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="认证方式" prop="authType">
            <el-select v-model="form.authType" placeholder="请选择认证方式" style="width: 100%;">
              <el-option v-for="item in authTypeOptions" :key="item.authTypeKey" :label="item.authTypeName"
                :value="item.authTypeKey">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="产品描述">
        <el-input type="textarea" rows="2" style="height: 100px !important;min-height: 100px !important;" v-model="form.productDescription" resize="none" :maxlength="255"></el-input>
      </el-form-item>

      <el-form-item label="离线提示语">
        <el-input type="textarea" :rows="2" style="height: 100px;min-height: 100px;" v-model="form.offlineInstructions" resize="none" :maxlength="255"></el-input>
      </el-form-item>
    </el-form>

    <ChooseTypeDrawe v-if="drawerFlag" :drawerFlag="drawerFlag" @closeDrawer="closeDrawer" @getData="receive" />
  </div>
</template>
<script>
// import { addProduct } from '@/api/productRegistration'
import ChooseTypeDrawe from '@/components/product_control/chooseTypeDrawe'
import eventBus from '@/assets/js/eventBus'
export default {
  props: {
    operate: {
      type: String
    },
    currentStep: {
      type: Number
    },
    productDetail: {
      type: Object
    },
    refresh: {
      type: Boolean
    },
    step: {
      type: Object
    }
  },
  components: {
    ChooseTypeDrawe
  },
  data() {
    const inputFocus = (rule, value, callback) => {
      if (this.form.categoryParentId === '' && this.form.categoryId === '') {
        callback(new Error('请选择产品品类'))
      } else {
        callback()
      }
    }
    const inputProductKey = (rule, value, callback) => {
      const reg = /^[A-Za-z0-9]+$/
      if (this.tag === 1) {
        if (this.form.productKey === '') {
          callback(new Error('产品标识不能为空'))
        } else if (this.form.productKey.length < 11) {
          callback(new Error('产品标识字符不得小于11'))
        } else if (this.form.productKey.length > 32) {
          callback(new Error('产品标识字符不得超过32个'))
        } else if (!reg.test(this.form.productKey)) {
          callback(new Error('产品标识只能由大小写字母，数字组成'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      tag: 0,
      categoryName: '',
      form: {
        productName: '', // 产品名称
        productKey: '', // 产品标识
        categoryParentId: '', // 父级ID
        categoryId: '', // 子品类id
        nodeType: '', // 节点类型
        connectionType: '', // 连网方式
        dataFormat: '', // 数据格式
        authType: '', // 认证方式
        productDescription: '' // 描述
      },
      rules: {
        productName: [
          { required: true, message: '请输入产品名称', trigger: 'blur' }
        ],
        category: [
          { required: true, validator: inputFocus, trigger: 'change' }
        ],
        productKey: [
          { validator: inputProductKey, trigger: 'blur' }
        ],
        nodeType: [
          { required: true, message: '请选择节点类型', trigger: 'change' }
        ],
        connectionType: [
          { required: true, message: '请选择连网方式', trigger: 'change' }
        ],
        dataFormat: [
          { required: true, message: '请选择数据格式', trigger: 'change' }
        ],
        authType: [
          { required: true, message: '请选择认证方式', trigger: 'change' }
        ]
      },
      focusStatus: true,
      autosize: { minRows: 6 }, // 设置textarea的最小高度
      nodeTypeOptions: [
        {
          nodeTypeName: '直连设备',
          nodeTypeKey: 0
        },
        {
          nodeTypeName: '网关子设备',
          nodeTypeKey: 1
        },
        {
          nodeTypeName: '网关设备',
          nodeTypeKey: 2
        }
      ],
      connectionTypeOptions: [
        {
          connectionTypeName: 'Wi-Fi',
          connectionTypeKey: '1'
        },
        {
          connectionTypeName: 'Zigbee',
          connectionTypeKey: '2'
        },
        {
          connectionTypeName: '蓝牙',
          connectionTypeKey: '3'
        },
        {
          connectionTypeName: '蜂窝网(2G/3G/4G/5G)', // 蜂窝网ETHERNET
          connectionTypeKey: '4'
        },
        {
          connectionTypeName: '以太网',
          connectionTypeKey: '5'
        },
        {
          connectionTypeName: 'LiRaWAN',
          connectionTypeKey: '6'
        },
        {
          connectionTypeName: '其他',
          connectionTypeKey: '7'
        }
      ],
      dataFormatOptions: [
        {
          dataFormatName: 'ICA标准数据格式(Alink JSON)',
          dataFormatKey: 0
        },
        {
          dataFormatName: '透传/自定义',
          dataFormatKey: 1
        }
      ],
      authTypeOptions: [
        {
          authTypeName: '设备密钥',
          authTypeKey: 0
        },
        {
          authTypeName: 'X.509证书',
          authTypeKey: 1
        }
      ],
      drawerFlag: false, // 抽屉开关
      status: false
    }
  },
  created() {
    eventBus.$on('resetFields', this.resetFields)
    eventBus.$on('mergeParams', this.nextStep)
    // 编辑的时候，需要初始化数据
    if (this.operate === 'edit') {
      this.initData()
    }
  },
  watch: {
    tag: {
      handler(val) {
        if (val === 0) {
          console.log('不需要验证')
          this.status = false
        } else {
          this.status = true
        }
      }
    },
    refresh() {
      this.initData()
    }
  },
  methods: {
    initData() {
      const initFormData = {
        productName: this.productDetail.productName, // 产品名称
        productKey: this.productDetail.productKey, // 产品标识
        productModelType: this.productDetail.productModelType, // 产品品类
        categoryParentId: this.productDetail.categoryParentId, // 父级ID
        categoryId: this.productDetail.categoryId, // 子品类id
        nodeType: this.productDetail.nodeType, // 节点类型
        connectionType: this.productDetail.connectionType.toString(), // 连网方式
        dataFormat: this.productDetail.dataFormat, // 数据格式
        authType: this.productDetail.authType, // 认证方式
        productDescription: this.productDetail.productDescription, // 描述
        offlineInstructions: this.productDetail.expandVo.offlineInstructions
      }
      let x = this.productDetail;
      debugger;
      this.form = initFormData
      console.log('initdata:', this.form)
    },
    resetFields() {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },
    closeDialog() {
      this.$emit('closeDialog')
    },
    // 提交
    nextStep() {
      console.log('setp1:', this.$refs.ruleForm)
      // this.$emit('nextStep', 2)
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) { // 验证成功
            Object.assign(this.productDetail, this.form)
            // if (this.tag === 0) {
            //   delete this.productDetail.productKey
            // }
            this.step.next = true
            console.log('this.productDetail:', this.productDetail)
            // this.$emit('nextStep', 2)
          }
        })
      }
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    // 打开抽屉
    openDrawer(e) {
      this.drawerFlag = true
      this.focusStatus = false
    },
    // 关闭抽屉
    closeDrawer() {
      this.drawerFlag = false
      this.focusStatus = true
    },
    // 获取抽屉传过来的值
    receive(val) {
      console.log('子组件数据', val)
      this.form.categoryId = val.categoryId
      this.form.categoryParentId = val.categoryParentId
      this.categoryName = val.categoryName
      this.drawerFlag = false
      this.focusStatus = true
    }
  }
}
</script>

<style lang='less' scoped>
/deep/ .el-textarea__inner {
  height: 80px !important;
  min-height: 80px !important;
}
</style>
